// Le texte d'un bloc est éclaté en plusieurs nœuds (liens linkify, etc.) :
// on cherche dans leur concaténation puis on reporte les offsets sur les nœuds.
// Si le motif a un groupe capturant (et le flag `d`), seul ce groupe devient un Range : le reste sert de contexte.
export function findTextRanges(root: Node, pattern: RegExp): Range[] {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
  const nodes: Text[] = []
  for (let n = walker.nextNode(); n; n = walker.nextNode()) {
    nodes.push(n as Text)
  }
  const text = nodes.map(n => n.data).join('')

  const ranges: Range[] = []
  for (const match of text.matchAll(pattern)) {
    if (!match[0]) continue
    const [start, end] = match.indices?.[1] ?? [
      match.index,
      match.index + match[0].length
    ]
    const range = document.createRange()
    let offset = 0
    let startSet = false
    for (const node of nodes) {
      const nodeEnd = offset + node.data.length
      if (!startSet && start < nodeEnd) {
        range.setStart(node, start - offset)
        startSet = true
      }
      if (end <= nodeEnd) {
        range.setEnd(node, end - offset)
        break
      }
      offset = nodeEnd
    }
    ranges.push(range)
  }
  return ranges
}

export function escapeRegExp(text: string) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
